import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Droppable } from 'react-beautiful-dnd'

import { getMonitorValue } from '../../functions'

import StageplanSidebarGroup from './stageplan-sidebar-group'
import StageplanSidebarItem from './stageplan-sidebar-item'

class StageplanSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedCategory: null
    }
  }

  render() {
    const { style, isDragging } = this.props
    const { selectedCategory } = this.state

    return (
      <Droppable droppableId={selectedCategory || 'sidebar'} type="stageplan">
        {(provided, snapshot) => (
          <div className="stageplan-sidebar" style={style}
            ref={provided.innerRef}>
            {
              selectedCategory
              ? <h5>Add {selectedCategory} to stage plan</h5>
              : <h5>Select a category</h5>
            }

            {
              selectedCategory
              ? <ul style={{maxHeight: `${style.height-50}px`}}>
                  <li className="stageplan-sidebar-link stageplan-sidebar-link--sticky"><a className="back" onClick={() => this.setState({selectedCategory: ''})}>Back to categories</a></li>
                  {
                    this.props.categories[selectedCategory].map((item, index) => {
                      if (item.id === undefined) return null

                      if (selectedCategory === 'misc' && item.children) {
                        return (
                          <StageplanSidebarGroup key={item.id || index}
                            item={item}
                            itemIndex={index}
                            fontSize={this.props.fontSize}
                            hideAnimation={this.props.hideAnimation}
                            setDragStartOffset={this.props.setDragStartOffset}
                            setRiderStageplanItemFocus={this.props.setRiderStageplanItemFocus}
                            createRiderStageplanItem={this.props.createRiderStageplanItem} />
                        )
                      } else {
                        return (
                          <StageplanSidebarItem key={item.id || index}
                            item={selectedCategory !== 'monitors' ? item : {...item, title: getMonitorValue(item)}}
                            itemIndex={index}
                            existingItem={item.stageplan_item}
                            fontSize={this.props.fontSize}
                            hideAnimation={this.props.hideAnimation}
                            setDragStartOffset={this.props.setDragStartOffset}
                            setRiderStageplanItemFocus={this.props.setRiderStageplanItemFocus}
                            createRiderStageplanItem={this.props.createRiderStageplanItem} />
                        )
                      }
                    })
                  }
                </ul>
              : <ul>
                  <li className="stageplan-sidebar-link"><a className="forward" onClick={() => this.setState({selectedCategory: 'members'})}>Members</a></li>
                  <li className="stageplan-sidebar-link"><a className="forward" onClick={() => this.setState({selectedCategory: 'instruments'})}>Instruments</a></li>
                  <li className="stageplan-sidebar-link"><a className="forward" onClick={() => this.setState({selectedCategory: 'monitors'})}>Monitors</a></li>
                  <li className="stageplan-sidebar-link"><a className="forward" onClick={() => this.setState({selectedCategory: 'misc'})}>Miscellaneous</a></li>
                  <li className="stageplan-sidebar-link"><a className="forward" onClick={() => this.props.addRiderStageplanItem()}>Custom</a></li>
                </ul>
            }

            {
              isDragging
              ? <div className="stageplan-remove-item">
                  <div className="stageplan-remove-item-overlay" />
                  <div className="stageplan-remove-item-drop h5" style={{padding: style.padding}} />
                </div>
              : null
            }

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    )
  }
}

StageplanSidebar.propTypes = {
  style: PropTypes.object,
  fontSize: PropTypes.number,
  categories: PropTypes.object,
  isDragging: PropTypes.bool,
  hideAnimation: PropTypes.bool,
  setDragStartOffset: PropTypes.func,
  setRiderStageplanItemFocus: PropTypes.func,
  addRiderStageplanItem: PropTypes.func,
  createRiderStageplanItem: PropTypes.func
}

StageplanSidebar.defaultProps = {
  style: {
    width: undefined,
    height: undefined,
    padding: undefined
  },
  fontSize: 12,
  categories: {},
  isDragging: false,
  hideAnimation: false,
  setDragStartOffset: function() {},
  setRiderStageplanItemFocus: function() {},
  addRiderStageplanItem: function() {},
  createRiderStageplanItem: function() {}
}

export default StageplanSidebar



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/stageplan-sidebar.js